import React, { useState } from "react";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";

export default function Signup() {
  const history = useHistory();

  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [modal, setModal] = useState({
    show: false,
    message: "",
    redirect: null
  });

  const showModal = (message, redirect = null) => {
    setModal({ show: true, message, redirect });
  };

  const closeModal = () => {
    setModal({ ...modal, show: false });
    if (modal.redirect) history.push(modal.redirect);
  };

  // ----------------- VALIDATION ------------------
  const validateForm = () => {
    if (!fullname.trim()) return "Full Name is required.";

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) return "Invalid email format.";

    const phoneRegex = /^[0-9+()\-\s]{6,20}$/;
    if (!phoneRegex.test(phone)) return "Invalid phone number.";

    if (password.length < 6)
      return "Password must be at least 6 characters.";

    if (password !== confirmPassword)
      return "Passwords do not match.";

    return null;
  };

  const handleSignup = async (e) => {
    e.preventDefault();

    const validationError = validateForm();
    if (validationError) {
      showModal(validationError);
      return;
    }

    try {
      const res = await axios.post("https://swiftexprofit.com/register", {
        fullname,
        email,
        phone,
        password,
      });

      showModal(res.data?.message || "Registration successful!", "/login");

    } catch (error) {
      showModal(error.response?.data?.message || "Registration failed");
    }
  };

  return (
    <div className="vh-100 d-flex justify-content-center">
      {/* MODAL */}
      {modal.show && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#1f1f1f",
              color: "#fff",
              padding: "25px",
              borderRadius: "8px",
              width: "400px",
              textAlign: "left",
              boxShadow: "0 8px 32px rgba(0,0,0,0.6)",
            }}
          >
            <h5 style={{ marginBottom: "10px" }}>Registration Status</h5>
            <p style={{ marginBottom: "20px" }}>{modal.message}</p>
            <button className="btn btn-primary" onClick={closeModal}>
              OK
            </button>
          </div>
        </div>
      )}

      {/* FORM */}
      <div className="form-access my-auto">
        <form onSubmit={handleSignup}>
          <span>Create Account</span>

          <div className="form-group">
            <input
              type="text"
              className="form-control"
              placeholder="Full Name"
              value={fullname}
              onChange={(e) => setFullname(e.target.value)}
              required
              style={{ color: "white" }}
            />
          </div>

          <div className="form-group">
            <input
              type="email"
              className="form-control"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{ color: "white" }}
            />
          </div>

          <div className="form-group">
            <input
              type="text"
              className="form-control"
              placeholder="Phone Number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
              style={{ color: "white" }}
            />
          </div>

          <div className="form-group">
            <input
              type="password"
              className="form-control"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{ color: "white" }}
            />
          </div>

          <div className="form-group">
            <input
              type="password"
              className="form-control"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              style={{ color: "white" }}
            />
          </div>

          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              className="custom-control-input"
              id="form-checkbox"
              required
            />
            <label className="custom-control-label" htmlFor="form-checkbox">
              I agree to the{" "}
              <Link to="/terms-and-conditions">Terms & Conditions</Link>
            </label>
          </div>

          <button type="submit" className="btn btn-primary">
            Create Account
          </button>
        </form>

        <h2>
          Already have an account?
          <Link to="/login"> Sign in here</Link>
        </h2>
      </div>
    </div>
  );
}
